import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useSearchParams, Navigate, useLocation } from 'react-router-dom';
import { userData } from '../../data/data_users';
import AuthUtils from '../../auth/auth_utils';
import { extractGuestInfo } from './guestUtils';
import './GuestJoin.css';



const GuestJoin = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [error, setError] = useState(null);
  const hasProcessedRef = useRef(false);





  useEffect(() => {
    if (hasProcessedRef.current) {
      console.log('🔄 Already processed guest join, skipping...');
      return;
    }
    hasProcessedRef.current = true;

    (async () => {
      try {
        const code = searchParams.get('code');
        if (!code) {
          setError('No guest code provided. Please check your invitation link.');
          return;
        }

        console.log('🔑 Processing guest code:', code);
        
        const response = await userData.getGuestToken(code);
        
        if (!response || !response.success) {
          const errorMessage = response?.message || 'Failed to retrieve guest token. Please check your connection and try again.';
          setError(errorMessage);
          return;
        }

        const { token } = response;

        // Set the token in cookies
        AuthUtils.SaveAuthToken(token);

        // Extract guest information from the token
        const guestInfo = extractGuestInfo(token);
        
        if (!guestInfo.success) {
          setError(`Invalid token: ${guestInfo.error}`);
          return;
        }

        const { instanceId, singleUserEmail } = guestInfo;
        
        // Save guest state to sessionStorage so it persists across the reload
        sessionStorage.setItem('guestState', JSON.stringify({
          guestMode: true,
          singleUserEmail,
          instanceId
        }));
        
        // Navigate to the meeting page
        window.location.href = `/meeting/${instanceId}`;

      } catch (err) {
        console.error('❌ Error in guest join process:', err);
        setError(err?.message || 'An unexpected error occurred');
      }
    })();
  }, [searchParams, navigate]);

  
  
  if (error) {
    return (
      <div className="guest-join-container">
        <div className="guest-join-content">
          <div className="error-icon">❌</div>
          <h2>Access Error</h2>
          <p className="error-message">{error}</p>
          <button 
            className="retry-button"
            onClick={() => window.location.reload()}
          >
            Try Again
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="guest-join-container">
      <div className="guest-join-content">
        <div className="loading-spinner"></div>
        <h2>Joining Meeting...</h2>
        <p>Please wait while we set up your guest access.</p>
      </div>
    </div>
  );
};

export default GuestJoin;
